import { AppState } from 'Store'

const selectAll = (state: AppState) => state.iBro.settings.trust.all
const selectParams = (state: AppState) => state.iBro.settings.trust.requestParams

export const trustSelector = {
	selectAll,
	selectParams,
}
